import { render, staticRenderFns } from "./RegularCoin.vue?vue&type=template&id=34ddde44&scoped=true&"
import script from "./RegularCoin.vue?vue&type=script&lang=tsx&"
export * from "./RegularCoin.vue?vue&type=script&lang=tsx&"
import style0 from "./regular_coin.scss?vue&type=style&index=0&id=34ddde44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ddde44",
  null
  
)

export default component.exports